import { Box, Button, Fab } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";


import { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchDataEngine } from "../../../../data/Axios/DynamicService";
import { HRService } from "../../../../config";
import StatutoryRateForm from "./StatutoryRateForm";
import { statutoryRatesColumns } from "../../../../data/Columns/hrmanagement";

import { tokens } from "../../../../theme";

const base_url = HRService.uri;

function StatutoryRateTable() {
  const location = useLocation();
// Define the correct GraphQL query for statutory rates
const AllStatutoryRate = `
  query AllStatutoryRate {
    allStatutoryRate {
       id
        statutoryComponentId
        lowerBound
        upperBound
        rate
        fixedAmount
        reliefAmount
        reliefType
        effectiveFrom
        effectiveTo
    }
  }
`;
    const data =JSON.parse(localStorage.getItem("StatutoryData"));

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const navigate = useNavigate();

    const handleGoBack = () => {
      const backPath = location.state?.from || "/payroll-setups";
      navigate(backPath);
    };

  const statutoryComponentId = data.id;
 const actions = {
  entity: "Payroll Setup",
  isSubright:true,
  

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  ViewStatutoryRatetLines: {
    key: "ViewStatutoryRatetLines",
    button_name: "View Brackets",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },  
  showStatus: true,
    modelName: "statutoryRateByStatutoryId", 
         dataObject: {
             // *** UPDATE: The input field must match the GraphQL variable (feeNotesLines) ***
             inputFields: {
              
                statutoryComponentId: statutoryComponentId,
                
            
            },
             
             // *** UPDATE: inputObjectName matches the GraphQL operation name (without 'query') ***
             inputObjectName: "statutoryRateByStatutoryId", 
             
             // *** UPDATE: inputSubObjectName is the array of results returned by the operation ***
             // Assuming the results array is directly returned by the operation.
             // If the API nests the array under another field, change this accordingly.
             inputSubObjectName: "statutoryRates", // Often the same as inputObjectName if the array is directly returned.
             
             returnFields: [
                 "id",
                 "statutoryComponentId",
                  "taxableAmount",
                 "lowerBound",
                 "upperBound",
                 "rate",
                 "fixedAmount",
                 "reliefAmount",
                 "reliefType",
                 "effectiveFrom",
                 "effectiveTo",
             ],
         },
};

  return (
    <Box m="2px">
      <>
        {/* Floating Back Button */}
        <Fab
          color="secondary"
          aria-label="go back"
          onClick={handleGoBack}
          sx={{
            position: "fixed",
            top: 120,      
            left: 265,     
            zIndex: 1100,
            width: 35,
            height: 35,
            boxShadow: 3,
            "&:hover": {
              boxShadow: 6,
            },
          }}
        >
          <ArrowBackIcon />
        </Fab>

        <DynamicTable
          title="Statutory Rates"
          subtitle="View all the Statutory Rates, create or update it"
          columns={statutoryRatesColumns}
          FormComponent={StatutoryRateForm}
        //  query={AllStatutoryRate}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default StatutoryRateTable;